// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lDWZ3MJA6Pgi97h12L8b{height:100%;padding-bottom:15px}.dT2KeeA6lsQ3q3MAHcqp{width:492px}.F3ALELh6uT8m6_xTwalC{width:992px}@media (max-width:992px){.dT2KeeA6lsQ3q3MAHcqp,.F3ALELh6uT8m6_xTwalC{max-width:628px}}@media (min-width:992px){.dT2KeeA6lsQ3q3MAHcqp,.F3ALELh6uT8m6_xTwalC{max-width:818px}}@media (min-width:1200px){.dT2KeeA6lsQ3q3MAHcqp,.F3ALELh6uT8m6_xTwalC{max-width:1032px}}.zPcIJzBi748Bqp1KkWif{background:var(--white-100);z-index:var(--zIndex-BASE_1);padding-top:30px;position:-webkit-sticky;position:sticky;top:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `lDWZ3MJA6Pgi97h12L8b`,
	"containerStepNarrow": `dT2KeeA6lsQ3q3MAHcqp`,
	"containerStepWide": `F3ALELh6uT8m6_xTwalC`,
	"pageNumberInfoContainer": `zPcIJzBi748Bqp1KkWif`
};
export default ___CSS_LOADER_EXPORT___;
